module.exports = __webpack_public_path__ + "static/media/alert_partner_platinum_x2_new.61c6ebb6.png";